import Entities from "./shared/Entities";

export default class Weather {
  constructor() {
    this.entities = new Entities("Weather", "[data-weather]", Weather.initSingle, Weather.destroySingle);
  }

  static async initSingle(containerEl) {
    const latEl = containerEl.querySelector("[data-weather-lat]");
    const lngEl = containerEl.querySelector("[data-weather-lng]");
    const targetTemp = containerEl.querySelector("[data-weather-temp]");

    if (!latEl || !lngEl || !targetTemp) return;

    const lat = latEl.dataset.weatherLat;
    const lng = lngEl.dataset.weatherLng;

    const apiUrl = `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lng}&current_weather=true&timezone=auto`;

    try {
      const res = await fetch(apiUrl);
      const data = await res.json();

      const temp = data?.current_weather?.temperature;

      if (temp !== undefined) {
        targetTemp.textContent = `${Math.round(temp)}`;
      } else {
        targetTemp.textContent = "--";
      }
    } catch (err) {
      console.error("Weather error:", err);
      targetTemp.textContent = "--";
    }
  }

  static destroySingle({ entityObj }) {
    entityObj?.destroy();
  }
}
